import { render, staticRenderFns } from "./form-comment.vue?vue&type=template&id=52a98636&"
import script from "./form-comment.vue?vue&type=script&lang=js&"
export * from "./form-comment.vue?vue&type=script&lang=js&"
import style0 from "./form-comment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/form-comment/form-comment.vue
// module id = 1003
// module chunks = 0